import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

export interface ResultViewColumn {
  name: string;
  order: number;
  visible: boolean;
}

export interface CreateUserResultViewDTO {
  viewName: string;
  isDefault: boolean;
  columns: ResultViewColumn[];
}

export interface UpdateUserResultViewDTO {
  viewName: string;
  isDefault: boolean;
  columns: ResultViewColumn[];
}

export interface UserResultView {
  id: number;
  viewName: string;
  isDefault: boolean;
  columns: ResultViewColumn[];
}

export interface CreateResultViewResponse {
  id: number;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ResultViewService {

  private readonly apiUrl = environment.backendApiConfiguration.api_url;

  constructor(private readonly http: HttpClient) { }

  getAllResultViews(): Observable<UserResultView[]> {
    return this.http.get<UserResultView[]>(`${this.apiUrl}users/resultview`);
  }

  createResultView(payload: CreateUserResultViewDTO): Observable<CreateResultViewResponse> {
    return this.http.post<CreateResultViewResponse>(`${this.apiUrl}users/resultview`, payload);
  }

  updateResultView(id: number, payload: UpdateUserResultViewDTO): Observable<any> {
    return this.http.put(`${this.apiUrl}users/resultview/${id}`, payload);
  }

  deleteResultView(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}users/resultview/${id}`);
  }
}
